import { apiClient } from "@/lib/api";
import type { StandardResponse } from "@/types/api-response";
import { extractData } from "@/types/api-response";
import type {
  CreateTenantDepositRequest,
  CreateTenantDepositResponse,
} from "@/types/tenant-deposit";

/**
 * Opening a top-up on a customer's behalf, by bank transfer or by QR.
 *
 * Only the create step is new. For a bank transfer the slip is uploaded through
 * `adminUploadService` and linked with `adminPaymentService.attachPaymentProof`, the same two
 * calls the payment detail screen already makes, and the credit happens when the payment is
 * verified from the payment queue. A QR deposit (`paymentMethod: "QRCode"`) comes back with a
 * T-PayGate bill and is credited by the gateway's webhook. SuperAdmin only — enforced server-side.
 */
export const adminTenantDepositService = {
  async createDeposit(
    tenantId: string,
    request: CreateTenantDepositRequest,
  ): Promise<CreateTenantDepositResponse> {
    const response = await apiClient.post<
      StandardResponse<CreateTenantDepositResponse>
    >(`/api/v1/admin/tenants/${tenantId}/deposits`, request);

    return extractData(response.data);
  },
};
